import { FC, useContext } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { OnlineStatusIndicator } from '../../incoming-conversation/NewConversationRequestCard';
import { TransferContext } from './TransferContext';

const OnlineIndicator: FC = () => {
  const { filteredAssociates, isLoading } = useContext(TransferContext);

  return (
    <Stack direction="row" gap={0.5} alignItems="center">
      <OnlineStatusIndicator $isOnline />
      <Typography variant="body2" color="textSecondary">
        Online:
      </Typography>
      {isLoading ? (
        <CircularProgress size={12} />
      ) : (
        <Typography variant="body2" color="textSecondary">
          {filteredAssociates.length}
        </Typography>
      )}
    </Stack>
  );
};

export default OnlineIndicator;
